import RoleEmployeesView from "../features/roles/RoleEmployeesView";

export default function RoleEmployeesPage() {
  return <RoleEmployeesView />;
}
